<template>
  <v-badge
    :color="badgeColor"
    :model-value="!!opinion.nonSegmentedOrderRank && !!opinion.orderRank.rank"
    floating
  >
    <template #badge>
      <template v-if="change === 0">-</template>
      <template v-else>
        <v-icon v-if="change > 0">mdi-arrow-up</v-icon>
        <v-icon v-else>mdi-arrow-down</v-icon>
        {{ Math.abs(change) }}
      </template>
    </template>
    <span class="text-no-wrap">
      {{ numberToOrdinal(opinion.orderRank.rank) }}
    </span>
  </v-badge>
</template>

<script setup lang="ts">
import { numberToOrdinal } from '@/composables/utilities';
</script>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'OpinionOrderRank',
  props: {
    opinion: {
      type: Object,
      default: null,
    },
  },
  computed: {
    change() {
      return this.opinion.nonSegmentedOrderRank - this.opinion.orderRank.rank;
    },
    badgeColor() {
      if (this.change === 0) {
        return 'blue-grey lighten-2';
      } else if (this.change > 0) {
        return 'success';
      } else {
        return 'error';
      }
    },
  },
});
</script>
